'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactivationModal = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactivationModal = exports.ReactivationModal = function ReactivationModal(_ref) {
  var onCtaClick = _ref.onCtaClick;
  return _react2.default.createElement(
    'div',
    { className: 'modal__reactivation' },
    _react2.default.createElement(
      'div',
      { className: 'modal__header' },
      _react2.default.createElement('img', { src: require('../../../static/img/modal-reactivation-welcome-bg.jpg'), alt: 'reactivated' })
    ),
    _react2.default.createElement(
      'div',
      { className: 'modal__body' },
      _react2.default.createElement(
        'div',
        { className: 'modal__column' },
        _react2.default.createElement(
          'h3',
          { className: 'delta sharp' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'reactivation.modal.header',
            defaultMessage: 'Reunited & It Sure Feels Good!'
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'mv+' },
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'span',
              { className: 'md-block' },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'reactivation.modal.welcome',
                defaultMessage: 'Let us be the first to say \u2013 welcome back to ClassPass!'
              })
            ),
            ' ',
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'reactivation.modal.message',
              defaultMessage: 'With your account reactivated, you can jump back into things and book your first class now!'
            })
          )
        ),
        _react2.default.createElement(
          'button',
          {
            onClick: function onClick() {
              return onCtaClick('ReactivationModal');
            },
            className: 'bt bt--primary bt--lg'
          },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'reactivation.modal.cta',
            defaultMessage: 'Book class'
          })
        )
      )
    )
  );
};

ReactivationModal.propTypes = {
  onCtaClick: _propTypes2.default.func.isRequired
};